<template>
  <div class="wrap-introd">
    <div class="container">
      <div class="close-icon" @click="closeHandle"><span class="el-icon-close"></span></div>
      <div ref="info" class="info">
        <div ref="infoText" class="text initialOrignUlLi" v-html="introduction">
        </div>
      </div>
      <div class="btn-group">
        <div class="flip">
          <div @click="scrollHandle('up')"><img src="/images/preloader/icon-up.png" alt=""><span>上翻</span></div>
          <div @click="scrollHandle('down')"><img src="/images/preloader/icon-down.png" alt=""><span>下翻</span></div>
        </div>
        <div class="close" style="margin: 0 0 0 40px;" @click="closeHandle"><img src="/images/preloader/icon_foot_close.png" alt=""><span>关闭</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      introduction: ''
    };
  },
  computed: {
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    }
  },
  created () {
    this.getHospitalInfo();
  },
  methods: {
    closeHandle () {
      this.$emit('close');
    },

    // 上翻下翻
    scrollHandle (type) {
      this.$nextTick(() => {
        console.log(this.$refs.info);
        console.log(this.$refs.info.scrollTop, type);
        let scrollTop = this.$refs.info.scrollTop;
        if (type === 'up') {
          this.$refs.info.scrollTop = scrollTop - 680;
        } else {
          this.$refs.info.scrollTop = scrollTop + 680;
        }
        console.log(this.$refs.info.scrollTop, type);
      });
    },
    // 查找医院介绍/
    async getHospitalInfo () {
      try {
        let data = await this.$apis.third.getHospitalInfo({
          buildId: this.buildInfo.buildId
        });
        let res = JSON.parse(data.data);
        console.log('查找医院介绍', res);
        this.introduction = res.introduction;
      } catch (error) {
        console.error('查找医院介绍报错信息:', error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wrap-introd {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: $color-opacity-regular;
  background-size: 100% 100%;
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 819px;
    width: 1450px;
    padding: 10px;
    transform: translate(-50%, -50%);
    background-image: url("/images/preloader/bg-symptom3.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // display: flex;
    padding: 38px;
    box-sizing: border-box;
    color: $color-white;
    .info{
      position: relative;
      height: calc(100% - 100px);
      font-size: 24px;
      line-height: 40px;
      overflow: auto;
      transition: all 1s;
      text-align: initial;
      line-height: inherit;
      line-height: inherit;
      font-size: initial;
      // letter-spacing: 1px;
    }
    .btn-group{
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > .flip {
        display: flex;
        height: 100px;
        align-items: center;
        justify-content: space-evenly;
        width: 240px;
         & > div {
          width: 100px;
          height: 40px;
          background: #3a6191;
          box-shadow: 0 0 10px $color-opacity-primary;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          border-radius: 50px;
          // margin: 0 40px 0 0;
          color: $color-white;
        }
        img {
          margin: 0 10px 0 0;
          width: 24px;
        }
      }
      img {
        width: 24px;
      }
      & > .close {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
       img {
         margin: 0 20px 0 0;
       }
      }

    }
  }
}
@media (orientation: portrait) {
  .wrap-introd {
    .container {
      height: 68vh;
      background: rgba(46,90,141,0.94);
      border-radius: 20px;
      .close-icon {
        display: block;
        position: absolute;
        top: -60px;
        right: 0;
        font-size: 38px;
        color: #ccc;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 50%;
        border: 2px solid #ccc;
        padding: 0;
        font-weight: bold;
        box-sizing: border-box;
      }
      .btn-group {
        .flip {
          width: 300px;
          & > div {
            width: 120px;
            height: 50px;
            font-size: 20px;
          }
        }
      }
    }
    .introd-middle {
      background: #476f9b;
      border-radius: 0 20px 20px 0;
      .content {
        height: calc(100% - 420px);
      }
      .list {
        height: calc(100% - 420px);
        padding: 0;
      }
    }
  }
}
</style>
